import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTwitterEmbed } from '../../../hooks';

/**
 * TwitterEmbed - Organism
 * Componente completo para embed de tweets
 * Usa hook customizado para gerenciar estado e lifecycle
 * Segue Atomic Design
 */
const TwitterEmbed = ({ article, isOpen, sx = {} }) => {
  const { embedRef, loading } = useTwitterEmbed(article, isOpen);

  const isTwitter = article?.mediaType === 'Twitter' ||
                    article?.siteName === 'X (Twitter)' ||
                    (article?.videoUrl && article.videoUrl.includes('x.com')) ||
                    (article?.siteUrl && article.siteUrl.includes('x.com'));

  if (!isTwitter) return null;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', sm: '100%', md: '550px' },
        margin: '0 auto',
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx
      }}
    >
      {loading && (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <CircularProgress size={32} />
          <Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
            Carregando tweet...
          </Typography>
        </Box>
      )}

      <Box
        ref={embedRef}
        sx={{
          width: '100%',
          borderRadius: '16px',
          overflow: 'hidden',
          backgroundColor: 'transparent',
          '& .twitter-tweet': {
            margin: '0 auto !important'
          },
          '& iframe': {
            display: 'block',
            width: '100% !important',
            maxWidth: '100% !important',
            border: '0 !important',
            borderRadius: '16px !important',
            backgroundColor: 'transparent !important',
            boxShadow: 'none !important'
          }
        }}
      />
    </Box>
  );
};

TwitterEmbed.propTypes = {
  article: PropTypes.object,
  isOpen: PropTypes.bool,
  sx: PropTypes.object
};

export default TwitterEmbed;
